import Vue from 'vue'
import Vuex from 'vuex'
import Crud from '../crud'
import app from '../../main'
import axios from 'axios'
import checkResponse from '@/utils/checkResponse'
const model = (payload) => ({
  // columns
  id: payload.id
})
var crud = new Crud('Warehouses', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  warehouses: []
}

const mutations = {
  ...crud.mutations
}

const actions = {
  ...crud.actions,
  async syncWarehouses ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`contpaq/warehouses`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_RECORDS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'primary', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  }
}

const getters = {
  ...crud.getters,
  warehouses: state => state.warehouses
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
